module.exports = __webpack_public_path__ + "assets/img/12.e167df20.png";